<script setup lang="ts">
/**
 * RlSearchCard component.
 *
 * Pass header slot contents and an array of item detail objects.
 * Can customize the item detail slot if necessary.
 * <rl-search-card :detail-items="[{header: "Number", value: n}]">
 *   <template #header>
 *     <span><b>SN:</b> {{ miner.sn }}</span>
 *     <el-tag>{{ miner.status }}</el-tag>
 *   </template>
 * </rl-search-card>
 */

defineProps<{ detailItems: { header: string; value: string }[] }>()
</script>

<template>
  <div class="h-full w-full flex flex-col justify-center items-center gap-2">
    <header class="w-full text-sm inline-flex justify-between items-center">
      <slot name="header" />
    </header>
    <div class="w-full grid grid-flow-col inline-grid auto-cols-fr gap-2">
      <template v-for="detailItem of detailItems" :key="detailItem.header">
        <slot name="item" v-bind="detailItem">
          <div class="flex flex-col gap-2">
            <p class="text-xs text-tertiary">{{ detailItem.header }}</p>
            <p class="text-ellipsis text-xs overflow-hidden">
              {{ detailItem.value }}
            </p>
          </div>
        </slot>
      </template>
    </div>
  </div>
</template>
